import { useState } from "react";
import { Info } from "lucide-react";
import { cn } from "@/lib/utils/helpers";
import { DESCRIPTION_TOOLTIP_SURFACE } from "@/lib/utils/descriptionTooltipStyles";
import type { YardiInfoTooltipProps } from "../../types";

/**
 * Matches Angular company-edit: `fa fa-info-circle` + `(mouseenter)` / `(mouseleave)` on
 * `.help-tooltip.communication_help.tooltip-right` (see company-edit.component.scss).
 */
export function YardiInfoTooltip({ children }: YardiInfoTooltipProps) {
    const [open, setOpen] = useState(false);
    return (
        <span
            className="relative inline-flex items-center align-middle"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            <button
                type="button"
                className="inline-flex cursor-pointer rounded p-0.5 text-green-600 hover:text-green-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500/40"
                aria-label="More information"
                tabIndex={0}
                onFocus={() => setOpen(true)}
                onBlur={() => setOpen(false)}
            >
                <Info className="h-4 w-4" aria-hidden />
            </button>
            {open && (
                <span
                    role="tooltip"
                    className={cn(
                        DESCRIPTION_TOOLTIP_SURFACE,
                        "absolute left-[calc(100%+10px)] top-1/2 z-[200] min-w-[240px] max-w-[min(300px,calc(100vw-3rem))] -translate-y-1/2 px-[15px] py-[15px] text-left text-[12px] leading-snug",
                    )}
                >
                    {children}
                </span>
            )}
        </span>
    );
}
